import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { logUsage } from 'owa-analytics';

/**
 * Log telemetry data that are Smart Reply with Meeting specific
 */
export default function logSmartReplyWithMeetingMetricProperties(
    eventMetricProperties: any,
    originalEvent: CalendarEvent,
    diffEvent: CalendarEvent,
    isTimeSuggestedByCASTaken: boolean,
    areOriginalRecipientsIncluded: boolean,
    extractionSourceId: string,
    eventCompletionType: string
) {
    const logData: { [key: string]: any } = {};

    // number of required and optional attendees
    logData.reqAttnCnt = eventMetricProperties.NumRequiredAttendees;
    logData.optAttnCnt = eventMetricProperties.NumOptionalAttendes;

    // Indicate if recipient list has been updated (ex: add/remove additional required /optional attendees)
    logData.reqAttnChanged = !!eventMetricProperties.RequiredAttendeesChanged;
    logData.optAttnChanged = !!eventMetricProperties.OptionalAttendeesChanged;

    // Indicate if original email recipients are included in the final meeting invite
    logData.allOrginAttn = areOriginalRecipientsIncluded;

    // Indicate if meeting start/end/event duration is different
    logData.mgtTimeChanged =
        !!diffEvent.Start || !!diffEvent.End || !!eventMetricProperties.DurationChanged;

    // Log meeting start/end time that are different from smart time (LuTimex) suggestion
    if (!!diffEvent.Start) {
        logData.prevStartTime = originalEvent.Start;
        logData.currStartTime = diffEvent.Start;
    }
    if (!!diffEvent.End) {
        logData.prevEndTime = originalEvent.End;
        logData.currEndTIme = diffEvent.End;
    }

    // Indicate if time suggestion from CAS is taken
    logData.useCAS = isTimeSuggestedByCASTaken;

    // Time (ms) user takes to complete scheduling a meeting
    logData.formOpenDuration = eventMetricProperties.FormOpenDuration;

    // Indicate if the meeting subject line has changed
    logData.subjectChanged = !!diffEvent.Subject;

    // Indicate if the meeting body has changed
    logData.contentChanged = eventMetricProperties.ContentChanged;

    //Indicate if location has changed
    logData.locationChanged = eventMetricProperties.LocationsSet;

    //extraction id (aka: entity id)
    logData.EID = extractionSourceId;

    const eventName: string =
        eventCompletionType === 'Discarded'
            ? 'DiscardCalendarDraftEventFromSmartPill'
            : 'CreateCalendarEventFromSmartPill';

    // datapoint logging - unsampled
    logUsage(eventName, [JSON.stringify(logData)], {
        isCore: true,
    });
}
